import moment from 'moment'

/**
 * Maps an "All" metric type to the corresponding metric in the performance reporting GraphQL response.
 *
 * If not an "All" type, returns the metric as is.
 */
const getMetric = metric => {
  switch (metric) {
    case 'netMarginAll':
      return 'netMargin'
    case 'netProfitAll':
      return 'netProfit'
    case 'businessProfitAll':
      return 'businessProfit'
    default:
      return metric
  }
}

/**
 * Formats a performance report data date into a readable string.
 */
const formatDate = date => {
  return moment.utc(date).format('dddd Do MMMM YYYY')
}

/**
 * Formats a performance report data date into recognisable date field in excel/spreadsheet client
 * ISO8601 date format
 */
const formatDateToISO = date => {
  return moment.utc(date).toISOString()
}

/**
 * Return child group data for a given groupId
 */
const getGroupData = (groups, groupId) => {
  let result
  for (let group of groups) {
    result = group.childGroups.find(child => child.groupId === groupId)
    if (!!result) return result
  }
}

/**
 * Calculates the number of selected stations or groups from an array of station and/or group ids.
 */
const calculateSelectedStationsAndGroupsAmount = (stationOrGroup = 'stations', selectedStationsAndGroups) => {
  if(stationOrGroup === 'stations') {
    return selectedStationsAndGroups.filter(item => item.includes('stat-')).length
  } else {
    return selectedStationsAndGroups.filter(item => !item.includes('stat-')).length
  }
}

/**
 * Return groups relevant to a search term
 */
function searchGroupsData(groupsData, searchTerm) {
  const lowerSearch = searchTerm.toLowerCase()

  return groupsData
    .map(group => {
      const filteredChildGroups = group.childGroups.filter(child =>
        child.name.toLowerCase().includes(lowerSearch)
      )

      if (filteredChildGroups.length > 0) {
        return {
          parentGroup: group.parentGroup,
          childGroups: filteredChildGroups,
        }
      }

      return null
    })
    .filter(Boolean)
}

export { getMetric, formatDate, formatDateToISO, getGroupData, calculateSelectedStationsAndGroupsAmount, searchGroupsData }
